import Page from 'containers/NewsPage'

export default Page
